import React from "react";
import useFetch from "@/lib/useFetch";
import { GlassCard, PageTitle, EmptyState } from "@/components/lux";
import { money } from "@/lib/api";
import { statusMeta, BscScanLink } from "@/components/DepositStatus";
import { Wallet } from "lucide-react";

export default function DepositHistory() {
  const { data, loading } = useFetch("/user/deposits");
  const deps = data?.deposits || [];
  return (
    <div className="space-y-6">
      <PageTitle title="Deposit History" subtitle="All your deposit requests and their status" />
      <GlassCard className="p-6" data-testid="deposit-history-table">
        {loading ? <div className="skeleton h-40" /> : deps.length ? (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="text-left text-[var(--text-dim)]"><tr className="border-b border-white/10">
                <th className="py-3">ID</th><th className="py-3">Token</th><th className="py-3">Network</th><th className="py-3">Amount</th><th className="py-3">Tx Hash</th><th className="py-3">Confirmations</th><th className="py-3">Status</th><th className="py-3">Date</th></tr></thead>
              <tbody>
                {deps.map((d) => {
                  const m = statusMeta(d.verification?.status || d.status);
                  return (
                  <tr key={d.dep_id} className="row-hover border-b border-white/5" data-testid={`deposit-row-${d.dep_id}`}>
                    <td className="py-3 text-white">{d.dep_id}</td><td className="py-3">{d.coin}</td><td className="py-3">{d.network}</td>
                    <td className="py-3 gold-text">${money(d.amount)}</td>
                    <td className="py-3"><BscScanLink hash={d.tx_hash} /></td>
                    <td className="py-3 text-[var(--text-dim)]">{d.verification?.confirmations != null && d.status !== "approved" ? `${d.verification.confirmations}${data?.required_confirmations ? ` / ${data.required_confirmations}` : ""}` : "—"}</td>
                    <td className="py-3"><span className={`rounded-full border px-2.5 py-1 text-xs font-semibold ${m.cls}`}>{m.label}</span></td>
                    <td className="py-3 text-[var(--text-dim)]">{(d.created_at || "").slice(0, 10)}</td>
                  </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : <EmptyState icon={Wallet} title="No deposits yet" hint="Your deposit requests will appear here." />}
      </GlassCard>
    </div>
  );
}
